import { render, staticRenderFns } from "./ReactionIcon.vue?vue&type=template&id=12afaa77&scoped=true"
import script from "./ReactionIcon.vue?vue&type=script&lang=ts"
export * from "./ReactionIcon.vue?vue&type=script&lang=ts"
import style0 from "./ReactionIcon.vue?vue&type=style&index=0&id=12afaa77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12afaa77",
  null
  
)

export default component.exports